/**
 * Web stand-in for `react-native-screens`.
 *
 * The Reusables overlay components import `FullWindowOverlay` and use it only
 * when `Platform.OS === 'ios'`; on web they substitute `React.Fragment`. The
 * import still has to resolve, so it lands here. Rendering the children through
 * a plain fragment matches what the components do on web anyway.
 */

import * as React from 'react';

/**
 * Renders its children unchanged.
 *
 * @param props Children to render.
 * @returns The children themselves.
 */
export function FullWindowOverlay(props: { children?: React.ReactNode }): React.ReactNode {
  return React.createElement(React.Fragment, null, props.children);
}
